import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { reportDemoIssue } from '../utils/demoIssues';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // D255: in a demo session, tell the platform admin a screen crashed (no-op otherwise).
    const where = (errorInfo && errorInfo.componentStack)
      ? String(errorInfo.componentStack).split('\n').map(s => s.trim()).filter(Boolean)[0]
      : '';
    reportDemoIssue({
      kind: 'screen_crash',
      message: `${(error && error.message) || 'Render error'}${where ? ` ${where}` : ''}`,
    });
  }

  handleReload = () => {
    // Reload the page to reset the app
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            p: 3,
            textAlign: 'center',
          }}
        >
          <Typography variant="h4" component="h1" gutterBottom>
            Oops! Something went wrong.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            We encountered an unexpected error. Please try reloading the page.
          </Typography>
          <Button variant="contained" onClick={this.handleReload}>
            Reload Page
          </Button>
        </Box>
      );
    }

    // Render children if no error
    return this.props.children;
  }
}

export default ErrorBoundary;